import { createTheme } from '@mui/material/styles';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';


import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/700.css';

import '@fontsource/unbounded/300.css';
import '@fontsource/unbounded/400.css';
import '@fontsource/unbounded/500.css';
import '@fontsource/unbounded/700.css';



export const theme = createTheme({
	typography: {
		fontFamily: [
			'Montserrat',
			'Unbounded',
			'sans-serif',
		].join(','),
	},
	components: {

		MuiFormControl: {
			defaultProps: {
				variant: 'outlined',
				size: 'small',
			},
		},

		MuiTextField: {
			defaultProps: {
				variant: 'outlined',
				size: 'small',
			},
		},

	},
});